export const blockIconsHomeLaundryNew = (
	<span className='material-symbols-outlined'>laundry</span>
);
